export default __webpack_public_path__ + "static/slide1-9baa4e1a0cc9760b75b096b3543caaca.svg";